/**
 * **URL: every one.** The root of the route tree — it matches no path of its own and sits
 * above every other route — plus any URL that matches nothing else, which is the 404 below.
 *
 * It owns deliberately little: an `<Outlet/>` and a not-found page. Why the providers split
 * between `main.tsx` and `_app.tsx` instead of sitting here, and why hoisting one up would
 * gain nothing, is `docs/structure.md`.
 *
 * **Everything below this file is authenticated.** `main.tsx` mounts `RouterProvider`
 * inside `<Authenticated>`, so no route in this tree ever renders for a signed-out
 * visitor — they get `Landing`, which lives outside the router entirely. Route code can
 * therefore assume a signed-in user without checking, and `useConvexAuth` appears in
 * `_app.tsx` only to decide whether a *query* may run yet.
 *
 * Being outside `_app.tsx`, the 404 renders with no app chrome and no garden context. That
 * is intentional: an unmatched URL may name no garden at all.
 */

import { Button } from '@mantine/core';
import { Outlet, createRootRoute, useNavigate } from '@tanstack/react-router';

import { FullPageMessage } from '../components/FullPageMessage';

// import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';

export const Route = createRootRoute({
  component: function RootComponent() {
    return (
      <>
        <Outlet />
        {/* <TanStackRouterDevtools /> */}
      </>
    );
  },
  // reachable because `public/_redirects` sends every unmatched path to the
  // SPA; without the catch-all there the CDN would 404 before this renders
  notFoundComponent: function NotFoundComponent() {
    const navigate = useNavigate();
    return (
      <FullPageMessage
        title="Page not found"
        body="That link doesn’t go anywhere. It may be out of date."
        action={
          <Button variant="light" onClick={() => void navigate({ to: "/" })}>
            Go to my gardens
          </Button>
        }
      />
    );
  },
})
